import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { filter, map, mergeMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class TitleService {
  private readonly APP_NAME = 'Sparq Splatform';
  private readonly TITLE_SEPARATOR = ' | ';

  constructor(
    private titleService: Title,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) {}

  /**
   * Initialize the title service to listen for route changes
   */
  init(): void {
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        map(() => this.activatedRoute),
        map(route => {
          while (route.firstChild) {
            route = route.firstChild;
          }
          return route;
        }),
        filter(route => route.outlet === 'primary'),
        mergeMap(route => route.data)
      )
      .subscribe(data => {
        const title = data['title'];
        this.setTitle(title);
      });
  }

  /**
   * Set the page title with the app name suffix
   * @param pageTitle - The page title to display
   */
  setTitle(pageTitle?: string): void {
    if (pageTitle) {
      this.titleService.setTitle(`${pageTitle}${this.TITLE_SEPARATOR}${this.APP_NAME}`);
    } else {
      this.titleService.setTitle(this.APP_NAME);
    }
  }

  /**
   * Get the current page title (without the app name suffix)
   */
  getCurrentTitle(): string {
    const fullTitle = this.titleService.getTitle();
    if (fullTitle.includes(this.TITLE_SEPARATOR)) {
      return fullTitle.split(this.TITLE_SEPARATOR)[0];
    }
    return fullTitle;
  }
}
